import { FaEye, FaPhoneAlt } from "react-icons/fa";
import { DashboardGaugeChart } from "@/components/sections/dashboard-gauge-chart";
import { DashboardStatMetric } from "@/components/sections/dashboard-area-line-chart";
import { DashboardPageIndicator } from "@/components/sections/dashboard-page-indicator";
import { DashboardStatCardShell } from "@/components/sections/dashboard-stat-card-shell";
import { DashboardTrendCard } from "@/components/sections/dashboard-trend-card";

export function RevenueLossCard({ className = "" }: { className?: string }) {
  return (
    <DashboardTrendCard
      title="Perte de revenus"
      value="-15 000€"
      chartId="hero-card-area-down"
      direction="down"
      tone="negative"
      decorative
      className={className}
    />
  );
}

export function ConversionCard({ className = "" }: { className?: string }) {
  return (
    <DashboardStatCardShell title="Taux de conversion" decorative className={className}>
      <DashboardGaugeChart progress={0.01} tone="negative" centerLabel="1%" />
    </DashboardStatCardShell>
  );
}

export function GooglePositionCard({ className = "" }: { className?: string }) {
  return (
    <DashboardStatCardShell title="Position Google" decorative className={className}>
      <p className="mt-1 text-xl font-bold tracking-tight text-red-500 xl:mt-1.5 xl:text-2xl">Page 4</p>
      <p className="mt-0.5 text-sm font-semibold text-zinc-400 xl:text-base">#38</p>
      <DashboardPageIndicator activePage={4} tone="negative" />
    </DashboardStatCardShell>
  );
}

export function LostClientsCard({ className = "" }: { className?: string }) {
  const bars = [38, 44, 40, 48, 52, 64];

  return (
    <DashboardStatCardShell title="Clients perdus" decorative className={className}>
      <p className="mt-1 text-xl font-bold tracking-tight text-[#1C1C1C] xl:mt-1.5 xl:text-2xl">150+</p>
      <div className="mt-2 flex h-10 items-end justify-between gap-1 xl:mt-3 xl:h-11">
        {bars.map((height, index) => (
          <span
            key={index}
            className={`w-3 rounded-sm xl:w-3.5 ${index === bars.length - 1 ? "bg-red-500" : "bg-zinc-200"}`}
            style={{ height: `${height}%` }}
          />
        ))}
      </div>
    </DashboardStatCardShell>
  );
}

export function GooglePositionProofCard({ className = "" }: { className?: string }) {
  return (
    <DashboardStatCardShell title="Position Google" align="center" className={className}>
      <p className="mt-1 text-xl font-bold tracking-tight text-emerald-600 xl:mt-1.5 xl:text-2xl">
        Page 1
      </p>
      <p className="mt-0.5 text-sm font-semibold text-zinc-400 xl:text-base">#4</p>
      <DashboardPageIndicator activePage={1} tone="positive" />
    </DashboardStatCardShell>
  );
}

export function ImpressionsProofCard({ className = "" }: { className?: string }) {
  const bars = [38, 44, 40, 48, 52, 64];

  return (
    <DashboardStatCardShell title="Impressions" align="center" className={className}>
      <DashboardStatMetric tone="neutral" icon={FaEye} centered>
        +4 070
      </DashboardStatMetric>
      <div className="mt-2 flex h-10 items-end justify-between gap-1 xl:mt-3 xl:h-11">
        {bars.map((height, index) => (
          <span
            key={index}
            className={`w-3 rounded-sm xl:w-3.5 ${index === bars.length - 1 ? "bg-emerald-500" : "bg-zinc-200"}`}
            style={{ height: `${height}%` }}
          />
        ))}
      </div>
    </DashboardStatCardShell>
  );
}

export function RandomAccentProofCard({ className = "" }: { className?: string }) {
  return (
    <DashboardTrendCard
      title="Trafic organique"
      value="+87%"
      chartId="proof-card-area-accent"
      direction="up"
      tone="positive"
      metricTone="neutral"
      align="center"
      className={className}
    />
  );
}

export function QualifiedCallsProofCard({ className = "" }: { className?: string }) {
  const bars = [38, 44, 40, 48, 52, 64];

  return (
    <DashboardStatCardShell title="Appels qualifiés" align="center" className={className}>
      <DashboardStatMetric tone="neutral" icon={FaPhoneAlt} centered>
        +7
      </DashboardStatMetric>
      <p className="mt-0.5 text-[10px] font-medium tracking-wide text-zinc-400 xl:text-xs">
        chaque mois
      </p>
      <div className="mt-2 flex h-10 items-end justify-between gap-1 xl:mt-3 xl:h-11">
        {bars.map((height, index) => (
          <span
            key={index}
            className={`w-3 rounded-sm xl:w-3.5 ${index === bars.length - 1 ? "bg-emerald-500" : "bg-zinc-200"}`}
            style={{ height: `${height}%` }}
          />
        ))}
      </div>
    </DashboardStatCardShell>
  );
}
